var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth__background hidden lg:block"},[_c('Splide',{attrs:{"options":_vm.options}},_vm._l((_vm.ThemeStore.loginPage.visuals),function(visual,idx){return _c('SplideSlide',{key:idx},[_c('div',{staticClass:"signin__content__splide__item",class:{item1: idx == 0},style:({
                'background-image': 'url(\'' + visual.url + '\')'
            })})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }